import React, { PropsWithChildren } from 'react';
import { Tag, TagType, TagVariant } from '@cmhc-schl/hearth-ui';
import styles from './styles.module.scss';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoanStatusPillProps {
  status: string;
  label: string;
  filled?: boolean;
  modified?: boolean;
}
export const getLoanStatusName = (status: string) => {
  switch (status) {
    case '00':
      return 'entered';
    case '01':
      return 'received';
    case '02':
      return 'cancelled';
    case '03':
      return 'rejected';
    case '04':
      return 'refused';
    case '05':
      return 'withdrawn';
    case '06':
      return 'approved';
    case '07':
      return 'issued';
    case '08':
      return 'risked';
    case '09':
      return 'finalized';
    case '10':
      return 'saved';
    case '11':
      return 'priced';
    case '12':
      return 'offer';
    case '14':
      return 'lock';
    case '15':
      return 'expired';
    case '90':
      return 'new';
    case '91':
      return 'rerisk';
    case '99':
      return 'critical';
    default:
      return 'unknown';
  }
};

const getStatusIndicatorColor = (status: string) => {
  switch (status) {
    case 'new':
      return 'Violet';

    case 'review':
    case 'refused':
    case 'rejected':
    case 'unknown':
    case 'issued':
    case 'received':
      return 'Brown';

    case 'fail':
    case 'critical':
      return 'Red';

    case 'pass':
    case 'approved':
    case 'finalized':
      return 'Green';

    case 'risked':
    case 'offer':
      return 'Teal';

    case 'delete':
    case 'entered':
      return 'Grey';

    case 'priced':
    case 'lock':
    case 'saved':
    case 'rerisk':
      return 'Yellow';

    case 'expired':
    case 'withdrawn':
    case 'cancelled':
      return 'DarkGrey';

    default:
      return 'Grey';
  }
};

const LoanStatusPill = ({
  status,
  label,
  modified,
  filled = true
}: PropsWithChildren<LoanStatusPillProps>) => {
  const { t } = useTranslation('HbtPortfolioManagementRequestOverview');

  return (
    <div className={styles.statusPillWrapper}>
      <Tag
        label={label}
        tagType={TagType.TAG}
        tagVariant={TagVariant.ICON_READONLY}
        statusIndicator={getStatusIndicatorColor(getLoanStatusName(status))}
        filled={filled}
      />
      {modified && (
        <Typography className={styles.modifiedTag} sx={{ fontStyle: 'italic' }}>
          ({t('PI-Portfolio-Management-Loans-Detail-Modified')})
        </Typography>
      )}
    </div>
  );
};

export default LoanStatusPill;
